export type CaseStudy = {
  slug: string;
  title: string;
  shortTitle: string;
  type: string;
  eyebrow: string;
  tagline: string;
  problem: string;
  solution: string;
  result: string;
  proof: string;
  link: string;
  screenshot: string;
  featured?: boolean;
};

export const caseStudies: CaseStudy[] = [
  {
    slug: 'solariumsdirect',
    title: 'Solariums Direct',
    shortTitle: 'Solariums',
    type: 'Custom kit commerce site',
    eyebrow: 'Home improvement website',
    tagline: 'A direct-to-buyer solarium site that feels specific, practical, and premium.',
    problem:
      'The business needed to sell a complex home-improvement offer without feeling like a generic showroom or lead broker.',
    solution:
      'Built a conversion-focused site with a sharp hero offer, visible quote path, product education, project proof, reviews, service area context, and planning resources.',
    result:
      'A live, mobile-ready sales surface with product education, project examples, and a visible quote path.',
    proof: 'Live website available to inspect',
    link: 'https://solariumsdirect.com/',
    screenshot: '/demos/solariumsdirect',
    featured: true,
  },
  {
    slug: 'wisdomchain',
    title: 'Anderson Leadership Foundation',
    shortTitle: 'Anderson Foundation',
    type: 'Nonprofit leadership website',
    eyebrow: 'Mission-driven organization',
    tagline: 'A leadership-support organization with a clear mission and route into its work.',
    problem:
      'The organization needed a public site that could explain its mission, whom it supports, and how visitors could understand the work.',
    solution:
      'Structured the site around the organization’s purpose, leadership context, and a focused route into its programs and resources.',
    result:
      'A live public surface organized around the foundation’s mission, leadership work, and ways to learn more.',
    proof: 'Live website available to inspect',
    link: 'https://wisdomchain.org/',
    screenshot: '/demos/wisdomchain',
  },
  {
    slug: 'pax',
    title: 'PAX Learning Center',
    shortTitle: 'PAX',
    type: 'Education brand site',
    eyebrow: 'Mission-driven redesign',
    tagline: 'A complete learning-center site with a clear application path and student proof.',
    problem:
      'The program needed to explain trust, flexibility, and support quickly for students comparing GED options.',
    solution:
      'Created a calm, structured site with program information, student stories, proof blocks, and direct application paths.',
    result:
      'A live education site that explains the program, support model, and application route in one coherent system.',
    proof: 'Live website available to inspect',
    link: 'https://paxlc.org/',
    screenshot: '/demos/pax',
  },
  {
    slug: 'orriadeskai',
    title: 'OrriaDeskAI',
    shortTitle: 'OrriaDeskAI',
    type: 'SaaS launch site',
    eyebrow: 'Product landing page',
    tagline: 'A focused AI product page with a clear story, demo path, and launch-ready polish.',
    problem:
      'A new AI productivity product needed a landing page that could explain the value quickly and move visitors toward a demo.',
    solution:
      'Built a modern SaaS page with crisp positioning, animated value props, integration proof, and calendar booking CTAs.',
    result:
      'A live product surface with focused positioning, integration context, and a visible demonstration path.',
    proof: 'Live website available to inspect',
    link: 'https://orriadeskai.com/',
    screenshot: '/demos/orriadeskai',
  },
];

export const featuredCaseStudy = caseStudies.find((study) => study.featured) ?? caseStudies[0];
export const supportingCaseStudies = caseStudies.filter((study) => study.slug !== featuredCaseStudy.slug);
